import { captureError } from './lib/sentry';

/**
 * Application configuration
 * Validates required environment variables at startup
 */

function getRequiredEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    const error = new Error(`Missing required environment variable: ${key}`);
    captureError(error, { key, available: Object.keys(import.meta.env) });
    console.error(`[Config] ${error.message}`);
    throw error;
  }
  return value;
}

// Validate on module load - will throw if missing
export const config = {
  apiUrl: getRequiredEnv('VITE_API_URL'),
  wsUrl: import.meta.env.VITE_WS_URL || getRequiredEnv('VITE_API_URL').replace('https://', 'wss://'),
} as const;
